import { ref, computed, onMounted, type ComputedRef } from 'vue'
import { useRoute } from 'vue-router'
import type { StyleProps } from './use-section-props'

/**
 * 图片配置接口
 */
export interface ImageConfig {
  width: number
  height: number
  url: string
  multiple: number
}

/**
 * 处理图片配置的 composable
 */
export function useSectionImage(mergedStyles: ComputedRef<StyleProps>) {
  const imageConfig = ref<ImageConfig>({
    width: 0,
    height: 0,
    url: '',
    multiple: 3,
  })

  const init = () => {
    const route = useRoute()
    if (route.meta.assetsMap) {
      const key = mergedStyles.value.bgI
      const asset = (
        route.meta.assetsMap as Record<
          string,
          {
            height: number
            size: string
            type: string
            url: string
            width: number
            multiple: number
          }
        >
      )?.[key || '']
      if (asset) {
        imageConfig.value.width = Number(asset.width)
        imageConfig.value.height = Number(asset.height)
        imageConfig.value.url = asset.url
        imageConfig.value.multiple = asset.multiple
      }
    }
  }

  onMounted(() => {
    init()
  })

  return {
    imageConfig: computed(() => imageConfig.value),
  }
}
